export const FORM_FETCH_REQUEST = 'FORM_FETCH_REQUEST';
export const FORM_FETCH_SUCCESS = 'FORM_FETCH_SUCCESS';
export const FORM_FETCH_FAILURE = 'FORM_FETCH_FAILURE';

export const FORM_SUBMIT_REQUEST = 'FORMS_SUBMIT_REQUEST';
export const FORM_SUBMIT_SUCCESS = 'FORM_SUBMIT_SUCCESS';
export const FORM_SUBMIT_FAILURE = 'FORM_SUBMIT_FAILURE';
